<template>
  <main
    class="page-container tw-bg-[#f8f8f8] tw-flex tw-flex-grow tw-relative tw-px-4 xl:tw-pt-[3.5rem] xl:tw-pt-[40px] xl:tw-px-52"
    role="main"
  >
    <div class="tw-w-full xl:tw-container xl:tw-mx-auto">
      <slot />
    </div>
  </main>
</template>

<script>
export default {}
</script>
